// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"fed034fc","122":"b76773cc"}[chunkId] + ".chunk.js";
};